<template>
  <table class="table tablesorter" :class="tableClass">
    <thead :class="theadClasses">
      <tr>
        <slot name="columns" :columns="columns">
          <th v-for="column in columns" :key="column">{{ column }}</th>
        </slot>
      </tr>
    </thead>
    <tbody :class="tbodyClasses">
      <tr v-for="(item, index) in data" :key="index">
        <slot :row="item" :index="index">
          <td
            v-for="(column, index) in colsWithValue(item)"
            :key="index">
            {{ itemValue(item, column) }}
          </td>
        </slot>
      </tr>
    </tbody>
  </table>
  <!-- <div class="overflow-auto">
    {{fields}}
    <b-table
      id="my-table"
      :items="data"
      :fields="fields"
      :per-page="perPage"
      :current-page="currentPage"
    >
      <template slot="img">
        <div style="width: 150px">..</div>
      </template>
      <template slot="title">
        <div style="width: 150px">..</div>
      </template>
    </b-table>

    <div class="card-footer d-flex justify-content-end bg-transparent">
          <b-pagination
            size="lg"
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            aria-controls="my-table"
          ></b-pagination>
    </div>

  </div> -->
</template>
<script>
export default {
  name: 'base-table',
  props: {
    fields: {
      type: Array,
      default: () => [],
      description: 'Table fields'
    },
    columns: {
      type: Array,
      default: () => [],
      description: 'Table columns'
    },
    data: {
      type: Array,
      default: () => [],
      description: 'Table data'
    },
    type: {
      type: String, // striped | hover
      default: '',
      description: 'Whether table is striped or hover type'
    },
    theadClasses: {
      type: String,
      default: '',
      description: '<thead> css classes'
    },
    tbodyClasses: {
      type: String,
      default: '',
      description: '<tbody> css classes'
    }
  },
  data() {
      return {
        perPage: 3,
        currentPage: 1,
      }
  },
  computed: {
    rows() {
        return this.data.length
    },
    tableClass() {
      return this.type && `table-${this.type}`;
    },
    colsWithValue() {
      return (row) => {
        return this.columns.filter(column => this.hasValue(row, column))
      }
    }
  },
  methods: {
    hasValue(item, column) {
      return item[column.toLowerCase()] !== 'undefined';
    },
    itemValue(item, column) {
      return item[column.toLowerCase()];
    }
  }
};
</script>
<style></style>
